import React from 'react';
import LazyLoad from 'react-lazyload';
import axios from 'axios';

const _loadedImages = {};
const _errorImages = {};
let galleryError = false;

const omniImageRegex = /image\d\.jdomni\.in/;

const isOmniImage = (imageUrl = '') => imageUrl.match(omniImageRegex);

const getJdImages = (contentBlockId) => {
	axios.get('/marketplace/cms/nj/genio/update-gallery?contentBlockId='+contentBlockId);
};

const RandomColorLoader = ({ randomColorObj }) => {
	return <div style={randomColorObj} />;
};

export default class ImageLoader extends React.Component {
	//initial state: image loaded stage
	state = {
		loaded: _loadedImages[this.props.imageSrc]
	};

	imageRef = React.createRef(null);

	componentDidMount = () => {
		const image = this.imageRef.current;
		if (image && image.complete) {
			if (image.naturalWidth != 0) {
				this.onLoad();
			} else {
				this.onError();
			}
		}
	}

	//image onLoad handler to update state to loaded
	onLoad = () => {
		_loadedImages[this.props.imageSrc] = true;
		if (this.props.setImageDimensionInfo && this.imageRef.current) {
			let width = this.imageRef.current.naturalWidth;
			let height = this.imageRef.current.naturalHeight;
			this.props.setImageDimensionInfo({
				ratio: width / height,
				width,
				height
			});
		}
		this.setState(() => ({ loaded: true }));
	};

	onError = () => {
		if (
			!galleryError &&
			this.props.blockType === 'gallery' &&
			!isOmniImage(this.props.imageSrc) &&
			this.props.contentBlockId
		) {
			getJdImages(this.props.contentBlockId);
			galleryError = true;
		}
		_errorImages[this.props.imageSrc] = true;
		this.setState(() => ({ loaded: false }));
	};

	getSmartFillDiv = () => (
		<div key='smart-fill-div' {...this.props.smartFillObj}></div>
	);

	render() {
		
		const {
			imageSrc,
			imgSrc,
			style,
			imgClass,
			imgAttrs,
			randomColorObj,
			smartFillObj,
			lazyLoadOffset,
			isPreviewDomain = false
		} = this.props;

		const disableLazyLoad = this.props.disableLazyLoad || isPreviewDomain;
		const loaderClass = disableLazyLoad || this.state.loaded ? 'img-loaded' : 'img-loading';
		let finalImageSrc = imageSrc;
		
		if (_errorImages[finalImageSrc]) {
			finalImageSrc = imgSrc;
		}
		
		const showRandomColorLoader = !disableLazyLoad && !this.state.loaded;
		
		let imageMarkup = (
			<React.Fragment>
				{smartFillObj && this.getSmartFillDiv()}
				{showRandomColorLoader && (
					<RandomColorLoader randomColorObj={randomColorObj} />
				)}
				<img
					ref={this.imageRef}
					src={finalImageSrc}
					style={(imgSrc && style) || {}}
					alt=''
					className={`${imgClass || ''} ${loaderClass}`}
					{...imgAttrs}
					onLoad={this.onLoad}
					onError={this.onError}
				/>
			</React.Fragment>
		);
		const shouldLazyLoadImage =
			!disableLazyLoad &&
			!this.state.loaded;
		if (shouldLazyLoadImage) {
			imageMarkup = (
				<LazyLoad
					offset={lazyLoadOffset || 650}
					once={true}
					placeholder={
						showRandomColorLoader ? (
							<RandomColorLoader
								randomColorObj={randomColorObj}
							/>
						) : (
							undefined
						)
					}
					{...this.props.lazyLoadProps}
				>
					{imageMarkup}
				</LazyLoad>
			);
		}
		return imageMarkup;
	}
}
